import { o as f } from "../../unsafe-svg-By8nNw37.js";
import { T as d, j as m, x as p, i as O, s as S } from "../../lit-element-6iugfgmM.js";
import { e as _ } from "../../custom-element-wk-AooBb.js";
import { n as h } from "../../property-BWlAHqg_.js";
import { t as u } from "../../state-STZTbIJp.js";
import "../../query-assigned-elements-B8U94KLQ.js";
import "../../sp-button-fa52iiKJ.js";
import { I as w, s as x, A as $ } from "../../strategies-D98BLkeE.js";
import { r as g } from "../../slottable-request-event-B1mW6PN4.js";
import { f as L } from "../../async-directive-DXZeVyIn.js";
import { e as T } from "../../directive-B5s9Ooqi.js";
import { o as C } from "../../if-defined-D-RhGngI.js";
import k from "../../events/SyncStateChangeEvent.js";
import { c as B } from "../../creative-cloud-icon-CELqJJSR.js";
class F extends L {
  render(t) {
    return d;
  }
  update(t, [e]) {
    this.template = e, this.target !== t.element && (this.target = t.element, this.renderBefore = this.target.children[0]), this.listenerHost = this.target, this.init();
  }
  handleSlottableRequest(t) {
    if (t.target !== t.currentTarget) return;
    const e = t.data === g;
    m(e ? void 0 : this.template(), this.target, { renderBefore: this.renderBefore });
  }
  init() {
    var t;
    (t = this.listeners) == null || t.abort(), this.listeners = new AbortController();
    const { signal: e } = this.listeners;
    this.listenerHost.addEventListener("slottable-request", (s) => this.handleSlottableRequest(s), { signal: e });
  }
  disconnected() {
    var t;
    (t = this.listeners) == null || t.abort();
  }
  reconnected() {
    this.init();
  }
}
const j = T(class extends F {
  constructor() {
    super(...arguments), this.defaultOptions = { triggerInteraction: "click", overlayOptions: { type: "auto", offset: 0 } }, this.options = { ...this.defaultOptions.overlayOptions };
  }
  render(n, t) {
    return d;
  }
  update(n, [t, e]) {
    var s, o, i, l;
    this.options = { ...this.defaultOptions.overlayOptions, ...e == null ? void 0 : e.overlayOptions }, this.insertionOptions = e == null ? void 0 : e.insertionOptions, this.template = t, this.host = (s = n.options) == null ? void 0 : s.host;
    let c = !1;
    const y = (e == null ? void 0 : e.triggerInteraction) || this.defaultOptions.triggerInteraction, v = w[(o = this.strategy) == null ? void 0 : o.type] !== y;
    this.target !== n.element && (this.target = n.element, c = !0), (c || v) && ((i = this.strategy) == null || i.abort(), this.strategy = new x[y](this.target, { isPersistent: !0, handleOverlayReady: (b) => {
      this.listenerHost = this.overlay = b, this.init();
    } })), this.strategy.open = (l = e == null ? void 0 : e.open) != null && l;
  }
  handleSlottableRequest(n) {
    var t, e;
    if (n.target !== n.currentTarget) return;
    const s = n.data === g, o = {};
    if (this.host && (o.host = this.host), m(s ? void 0 : this.template(), this.overlay, o), s) this.overlay.remove();
    else {
      $.applyOptions(this.overlay, { ...this.options, trigger: this.target });
      const i = typeof ((t = this.insertionOptions) == null ? void 0 : t.el) == "function" ? this.insertionOptions.el() : ((e = this.insertionOptions) == null ? void 0 : e.el) || this.target, { where: l = "afterend" } = this.insertionOptions || {};
      i.insertAdjacentElement(l, this.overlay);
    }
  }
}), I = O`:host{--button-width: fit-content;--icon-margin: 3px;--icon-shrink-margin-left: 8px;min-width:var(--button-width)}:host([shrink]){--button-width: 30px}sp-button{--mod-button-border-radius: 50px;max-width:var(--button-width);min-width:var(--button-width)}:host([shrink]) [part=wide-view]{display:none}[slot=icon]{margin-top:var(--icon-margin)}:host([shrink]) [slot=icon]{margin-left:var(--icon-shrink-margin-left)}`;
var q = Object.defineProperty, E = Object.getOwnPropertyDescriptor, a = (n, t, e, s) => {
  for (var o, i = s > 1 ? void 0 : s ? E(t, e) : t, l = n.length - 1; l >= 0; l--) (o = n[l]) && (i = (s ? o(t, e, i) : o(i)) || i);
  return s && i && q(t, e, i), i;
};
let r = class extends S {
  constructor() {
    super(...arguments), this.disabled = !1, this.pending = !1, this.synced = !1, this.treatment = "", this.renderTooltip = () => p`${this._label}`, this._handleUnsyncSlotChange = (n) => {
      var e;
      const t = n.target;
      this._unsyncTextFromSlot = (e = t.assignedElements()[0]) == null ? void 0 : e.innerHTML;
    }, this._handleDefaultSlotChange = (n) => {
      var e, s;
      const t = n.target;
      this._syncTextFromSlot = (s = (e = t.assignedNodes()[0]) == null ? void 0 : e.textContent) == null ? void 0 : s.trim();
    };
  }
  static get styles() {
    return I;
  }
  get _syncLabel() {
    return this.syncLabel ?? this._syncTextFromSlot;
  }
  get _unsyncLabel() {
    return this.unsyncLabel ? this.unsyncLabel : this._unsyncTextFromSlot;
  }
  get _label() {
    return this.synced ? this._unsyncLabel : this._syncLabel;
  }
  render() {
    return p`<sp-button label="${this._label}" variant="${this.synced ? "secondary" : "primary"}" treatment="${this.treatment}" @click="${this._handleClick}" ?disabled="${this.disabled}" ?pending="${this.pending}" ${this._label ? function(n, t) {
      return j(() => (import("../../sp-tooltip-RAJ82M3n.js"), p`
                <sp-tooltip variant=${C(t == null ? void 0 : t.variant)}>
                    ${n()}
                </sp-tooltip>
            `), { ...t, triggerInteraction: "hover", overlayOptions: { type: "hint", ...t == null ? void 0 : t.overlayOptions } });
    }(this.renderTooltip, { overlayOptions: { delayed: !0, placement: "top" } }) : d}><span part="wide-view">${this.renderContent()}</span> <span slot="icon">${f(B)}</span></sp-button>`;
  }
  renderContent() {
    return this.synced ? this.renderUnsyncSlot() : this.renderSyncSlot();
  }
  renderSyncSlot() {
    return p`<slot @slotchange="${this._handleDefaultSlotChange}">${this._syncLabel}</slot>`;
  }
  renderUnsyncSlot() {
    return p`<slot name="unsync-content" @slotchange="${this._handleUnsyncSlotChange}">${this._unsyncLabel}</slot>`;
  }
  _handleClick() {
    this.dispatchEvent(new k());
  }
};
a([h({ type: Boolean })], r.prototype, "disabled", 2), a([h({ type: Boolean })], r.prototype, "pending", 2), a([h({ type: Boolean })], r.prototype, "synced", 2), a([h({ type: String })], r.prototype, "syncLabel", 2), a([h({ type: String })], r.prototype, "unsyncLabel", 2), a([h({ type: String })], r.prototype, "treatment", 2), a([u()], r.prototype, "_syncTextFromSlot", 2), a([u()], r.prototype, "_unsyncTextFromSlot", 2), r = a([_("af-sync-button")], r);
const W = r;
export {
  W as default
};
//# sourceMappingURL=SyncButton.js.map
